import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../../../../../styles/const/colors'

export default createUseStyles({
  list: {
    color: darkGrey
  }
})
